if (!customElements.get("switch-product-collection")) {
  class SwitchProductCollection extends HTMLElement {
    constructor() {
      super();
      this.switchList = $(".switch .switch-item");
      this.initSwitchClick();
    }
    initSwitchClick() {
      const that = this;
      this.switchList.click(function () {
        that.switchList.removeClass("active");
        $(this).addClass("active");
        $(".collection-cont").removeClass("show");
        $(".collection-cont").eq($(this).index()).addClass("show");
        $(".collection__view-all").removeClass("show");
        $(".collection__view-all").eq($(this).index()).addClass("show");
      });
    }

  }
  customElements.define("switch-product-collection", SwitchProductCollection);
}
